import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { CheckCircle, XCircle, AlertTriangle, Info, Loader2 } from "lucide-react"

function getToastIcon(variant?: string) {
  switch (variant) {
    case "success":
      return <CheckCircle className="h-5 w-5 text-green-500 flex-shrink-0" />
    case "destructive":
      return <XCircle className="h-5 w-5 text-red-500 flex-shrink-0" />
    case "warning":
      return <AlertTriangle className="h-5 w-5 text-amber-500 flex-shrink-0" />
    case "info":
      return <Info className="h-5 w-5 text-blue-500 flex-shrink-0" />
    case "loading":
      return <Loader2 className="h-5 w-5 text-slate-500 animate-spin flex-shrink-0" />
    default:
      return <Info className="h-5 w-5 text-slate-500 flex-shrink-0" />
  }
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start gap-3 flex-1">
              {getToastIcon(variant || 'default')}
              <div className="flex-1 grid gap-1">
                {title && <ToastTitle className="text-sm font-medium leading-5">{title}</ToastTitle>}
                {description && (
                  <ToastDescription className="text-sm leading-5 opacity-90">{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
